<template>
  <div id="data-view">
    <dv-full-screen-container v-show="!is_Show" :class="{xian:type>0}">

      <top-header v-if="type<1"/>

      <div class="main-content">
        <digital-flop :total="total" :list="list"/>

        <div class="block-left-right-content">
          <dv-loading v-if="!countryTotal.length">Loading...</dv-loading>
          <div style="position: relative" v-else class="main-map">
            <dv-border-box-8 class="map_box">
              <fly :config="config" style="width:100%;height: 100%"/>
            </dv-border-box-8>
            <span
              class="bottom_text"
              style="">系统无故障运行{{ days }}天</span>
            <TimeBox></TimeBox>
            <div style="" class="total_box">
              <p class="total_box_title">总订单：</p>
              <template v-for="item in countryTotal">
                <p class="total_box_item" :key="item.name"
                   v-if="item.name!=='郑州' && item.count">
                  <img style="" :src="item.icon.src" alt="">
                  <span style="">{{ item.count }}</span>
                </p>
              </template>
            </div>
            <div style="display: flex;width: 100%">
              <dv-decoration-3 style="width:25%;height:20px;"/>
              <dv-decoration-3 style="width:25%;height:20px;"/>
              <dv-decoration-3 style="width:25%;height:20px;"/>
              <dv-decoration-3 style="width:25%;height:20px;"/>
            </div>

          </div>
          <div class="block-top-bottom-content">
            <div class="block-top-content">
              <scroll-board :order="order"/>
            </div>
            <div class="block-top-content">
              <rankingBoard :packages="packages"></rankingBoard>
            </div>

          </div>
        </div>
      </div>
    </dv-full-screen-container>
    <div v-show="is_Show"
         style="width: 100%;height: 100%;background: #fff;display: flex;align-items: center;justify-content: center">
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: flex-start">
        <h1 style="color: #030409">请登录</h1>
        <input type="text" v-model="email" placeholder="请输入邮箱">
        <input type="password" v-model="password" placeholder="请输入密码">
        <button @click="login">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import Fly from './fly.vue'
import topHeader from './topHeader'
import digitalFlop from './digitalFlop'
import rankingBoard from './bagBoard'

import scrollBoard from './scrollBoard'
import bgImg from '../../assets/map.jpg'
import ctImg from '../../assets/img.png'
import {colors, pointsList} from '@/components/data'
import {getCountConfig, getOrderConfig, getPackageConfig, getTotal} from '@/components/util/methods'
import TimeBox from './time-box.vue'

export default {
  name: 'DataView',
  components: {
    topHeader,
    digitalFlop,
    rankingBoard,
    Fly,
    scrollBoard,
    TimeBox
  },
  data() {
    return {
      days: 0,
      flag: true,
      show: true,
      is_total: false,
      type: 0,
      colors: colors,
      total: [],
      list: [],
      countryTotal: [],
      time: null,
      email: '',
      is_Show: true,
      baseUrl: 'https://center.niubeiapp.com',
      password: '',
      token: '',
      order: {
        header: ['时间', '订单编号', '金额', '用户'],
        data: [],
        columnWidth: [150, 165, 60, 160],
        align: ['center'],
        rowNum: 9,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      },
      packages: {
        header: ['时间', '国际物流单号', '国家', '用户'],
        data: [],
        columnWidth: [150, 165, 70, 150],
        align: ['center'],
        rowNum: 9,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      },
      is_xian: false,
      config: {
        points: pointsList,
        lines: [],
        icon: {
          show: true,
          src: ctImg
        },
        text: {
          show: true,
          fontSize:document.body.clientWidth>1700? 18:12
        },
        k: -1,
        bgImgSrc: bgImg
      }
    }
  },
  methods: {
    login: function () {
      const token = localStorage.getItem('token')
      if (token && token !== 'null') {
        this.token = token
      }
      if(this.token){
        this.getData()
        this.is_Show = false
        return;
      }
      if (!this.email) {
        alert('请输入邮箱')
        return
      }
      if (!this.password) {
        alert('请输入邮箱')
        return
      }
      const data = {
        email: this.email,
        password: this.password
      }
      fetch(this.baseUrl + '/view/login', { // must match 'Content-Type' header
        cache: 'no-cache',
        headers: {
          'Domain': this.baseUrl,
          'content-type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(data),
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer'
      }).then(res => res.json()).then(res => {
        // eslint-disable-next-line camelcase
        const {access_token: token} = res.data
        if (token) {
          localStorage.setItem('token', token)
          this.token = token
          this.getData()
          this.is_Show = false
        }
      })
    },
    getCountConfig(n) {
      return getCountConfig(n)
    },
    getRandomCountry(target) {
      pointsList.forEach(item => {
        const flag = Math.random() > 0.8
        if (flag && !target[item.name]) {
          if (item.name !== '郑州') {
            target[item.name] = 2
          }
        }
      })

    },
    getLines(orders = {}, packages = []) {
      const countryTotal = []
      const points = this.config.points
      const lines = []
      let target = []
      points.forEach(item => {
        countryTotal.push({
          count: orders[item.name] || 0,
          name: item.name,
          icon: item.icon
        })
        target.push(item.name)
      })
      countryTotal.sort((a, b) => b.count - a.count)
      this.countryTotal = countryTotal
      const list = {}
      packages.length && packages.forEach(item => {
        if (list[item.country]) {
          list[item.country]++
        } else {
          list[item.country] = 2
        }
      })
      //this.getRandomCountry(list)
      Object.keys(list).forEach(key => {
        if (target.indexOf(key) > -1) {
          let color = this.colors[this.getRandom(5)]

          lines.push({
            source: this.is_xian ? '西安' : '郑州',
            target: key,
            color,
            width: list[key] > 4 ? 4 : list[key],
            orbitColor: `${color}05`,
            duration: [50, 50],
            radius: key === '日本' ? 50 : 600
          })
        }
      })
      // this.$set(this.config, 'lines', lines)
      // this.show = false
      this.config = {...this.config, lines}
      // this.show = true
      // this.$forceUpdate()
    },
    getRandom(m) {
      return Math.ceil(Math.random() * m)
    },
    getData() {
      if (!this.flag) {
        return
      }
      if (!this.token) {
        return
      }
      let url = this.baseUrl + '/view/data-view'
      if (this.is_total) {
        url += '?times=25&type=1'
      } else if (this.type > 2) {
        url += '?times=25&type=' + this.type
      }
      // let url = 'https://app.niubeiapp.com/view/data-view'
      this.flag = false
      fetch(url, { // must match 'Content-Type' header
        cache: 'no-cache',
        headers: {
          'Domain': this.baseUrl,
          'content-type': 'application/json',
          'authorization': `Bearer ${this.token}`
        },
        method: 'GET',
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer'
      }).then(res => res.json()).then(res => {

        if (!res.data) {
          this.is_Show = true
          this.token = ''
          localStorage.removeItem('token')
          return
        }
        this.is_Show = false
        requestAnimationFrame(() => {
          const {total, country_orders: countryOrders, package: packages, order} = res.data
          this.total = getTotal(total, this.type > 2)
          this.getLines(countryOrders, packages)
          this.order = getOrderConfig(order)
          this.list = order.map(item => item.amount).filter(item=>item)
          this.packages = getPackageConfig(packages)
          this.flag = true
        })
      }).catch(() => {
        console.log(1)
        this.is_Show = true
      })
    },
    getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 正则语句
      let r = window.location.search.substr(1).match(reg) // 获取url的参数部分，用正则匹配
      if (r != null) {
        return decodeURIComponent(r[2]) // 解码得到的擦拭农户
      }
      return null
    },
    getDays() {
      const t = this.getQueryString('t')

      const today = t ? new Date(Number(t)).getTime() : new Date().getTime()
      const last = new Date('2020-10-1').getTime()

      this.days = Math.ceil((today - last) / 1000 / 3600 / 24)
    }
  },
  mounted() {
    const name = this.getQueryString('name')
    const type = this.getQueryString('type')
    this.is_xian = name && name.indexOf('陕') > -1
    this.is_total = type && type > 0 && type < 2
    this.type = type
    if (type > 0) {
      this.is_xian = true
      this.is_Show = false
      this.email = 'test@niubei.com'
      this.password = '11111111'
      this.login()
    }
    if (this.is_xian) {
      this.config.points[0].name = '西安'
      this.config.points[0].coordinate = [0.75, 0.42]
    }

    const token = localStorage.getItem('token')
    if (token && token !== 'null') {
      this.token = token
    }
    this.getData()
    this.getDays()
    const points = this.config.points
    points.forEach(item => {
      item.halo = {show: true, radius: 40}
    })
    this.config = {...this.config, points}
    this.time = setInterval(() => {
      this.getData()
      this.getDays()
    }, 3.1e5)
  },
  beforeDestroy() {
    clearInterval(this.time)
    this.time = null
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;


  .total_box {
    position: absolute;
    top: 10px;
    left: 10px;

    .total_box_title {
      font-size: 30px;
      color: #fff;
      font-weight: bold
    }

    .total_box_item {
      font-size: 20px;
      display: flex;
      align-items: center;
      margin: 30px 0;

      img {
        width: 55px;
        margin-right: 8px;
      }

      span {
        font-size: 45px;
        color: #fff;
        font-weight: bold;
      }
    }
  }

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;

    &.xian {
      background-image: url("./bg.png");
    }
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }

  .block-top-bottom-content {
    width: 20%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }

  .block-top-content {
    height: 75%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }

  .bottom_text {
    position: absolute;
    font-size: 60px;
    bottom: 30px;
    left: 80px;
    color: white
  }

  input {
    -webkit-appearance: none;
    width: 400px;
    height: 50px;
    border-radius: 4px;
    margin: 10px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    outline: none;
    font-size: 28px;
    padding: 0 15px;
  }

  button {
    -webkit-appearance: none;
    box-sizing: border-box;
    width: 400px;
    height: 50px;
    border: 1px solid #ccc;
    outline: none;
    background: #222;
    color: #fff;
    margin: 10px;
    border-radius: 4px;
    font-size: 35px;
  }

  .main-map {
    width: 80%;
  }

  .map_box {
    padding: 3px;
    height: 98%
  }
}

@media screen and (max-width: 2000px) {
  #data-view {
    .bottom_text {

      font-size: 30px;
      bottom: 40px;
      left: 40px;

    }

    .main-content {
      height: 80%;
    }

    .total_box {


      .total_box_title {
        font-size: 20px;
        color: #fff;
        font-weight: bold
      }

      .total_box_item {
        font-size: 10px;
        display: flex;
        align-items: center;
        margin: 15px 0;

        img {
          width: 27px;
          margin-right: 4px;
        }

        span {
          font-size: 20px;
          color: #fff;
          font-weight: bold;
        }
      }
    }

    #dv-full-screen-container {

      box-shadow: 0 0 2px blue;

    }


    .block-left-right-content {

      margin-top: 10px;
    }

    .block-top-bottom-content {
      width: 28%;

      padding-left: 10px;
      padding-bottom: 20px;
    }

    .block-top-content {
      height: 75%;

      padding-bottom: 10px;
    }


    .main-map {
      width: 72%;
    }

    .map_box {
      padding: 3px;
      height: 96%
    }
  }
}
@media screen and (max-width: 1700px) {
  #data-view {
    .bottom_text {

      font-size: 25px;
      bottom: 62px;
      left: 32px;

    }

    .main-content {
      height: 80%;
    }

    .total_box {


      .total_box_title {
        font-size: 17px;
        color: #fff;
        font-weight: bold
      }

      .total_box_item {
        font-size: 9px;
        display: flex;
        align-items: center;
        margin: 12px 0;

        img {
          width: 22px;
          margin-right: 4px;
        }

        span {
          font-size: 17px;
          color: #fff;
          font-weight: bold;
        }
      }
    }

    #dv-full-screen-container {

      box-shadow: 0 0 2px blue;

    }


    .block-left-right-content {

      margin-top: 9px;
    }

    .block-top-bottom-content {
      width: 29%;

      padding-left: 8px;
      padding-bottom: 17px;
    }

    .block-top-content {
      height: 75%;

      padding-bottom: 8px;
    }


    .main-map {
      width: 71%;
    }

    .map_box {
      padding: 2px;
      height: 92%
    }
  }
}
</style>
